<template>
  <div class="person">
    <div class="topContent">
      <div class="topArea">
        <div class="head_area">
          <div class="leftImg">
            <!--                <img src="/static/img/logo_icon.8abe279d.png" class="top_back">-->
          </div>
          <span class="head_text">{{ $t('我的') }}</span>
          <a target="_blank" href="https://app.u58u.com/" class="right_menu">
            <img src="/static/image/new/download-icon.png" alt="" class="right_menu_img">
          </a>
        </div>
        <div class="part1">
          <div class="avatarBox">
            <img @click="go('/userInfo')"
                 :src="$store.state.userInfo.avatar ? $store.state.userInfo.avatar : '/static/image/logo2.png'"
                 onerror="this.src=&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAqCAMAAAAd31JXAAAA3lBMVEXx8fFPj/9Qjf/KysrOzs7z8/Pm5ub5+fr29vb39/f4+Pnv7+/r6+tXkv9TkP/z9v3u7u7d3d3R0dFVkv/s8f2xy/9el/9alf/7+/uEr/9+q/9onf9kmv/19/rT09PP3v+90f+Ntf+CrP93pv/i6v7T4f78/f3h4eGmxP+jwv+Suf+Isf9gmP/+/v7m7f7K2P74+vzZ2dnV1dXD1f+sx/96qP9zpP9vof9sn//f6P7f39+2zv+ewP+bvf+WuP+Lsv/a5f7Y4v7a5P3o6OjX19e30P/o7v7K2/7v8/zj4+N7hHehAAACO0lEQVQ4y4XV53qiQBQG4GERZkDpXQiCBevae4luNJvk/m8oEQVmFOP3+30OhzMN/CEiLMrdTsvYGNvQmbkaRQS3olfdDlaSDePob0GnZuZbsdfd1CGPGBCHQRyUGq2alWO12rQPY5iF4aXGzr2zQlgZokxlWn+fa6S1XvuQAXlBLx+OhVthp/PgQZiXhqNlVuvoHAlIXCmnVqz2yarFYpHEk0Vi3QrEYampKGsW1+hz2rtYoT1kMMqOCzRN+00ccyvnYhf/8WZLPh1H/SK62HhnK7QivIM1fc1Jxruo78/WrBNlx4lVWaKwYVJA7EYMbtXEFpoAC9eYUUAIbJBv18Ty6R0KWCuOsH7aQ5OccVsE1pDYB7KSWL8E8PDvHlhG5JKxhWsLShHg4So14PwFIK/wuARI+68MXm8sOKrZFLCgt+q9LY2wbknbzbdj+db+9LAkbfGoFC6/drz/NxOfmcyO/GQO/ojFa/OBB6xsO8hfJ5XGoo6aqWb4lgaECUw3biIzfWITe15jcR8x2WDvomTj/dmT3nWry+tCThLLG+Z5rxvR9ZyxObmOGfXD+AzNdQSehOEDN7bC1GaeWFQPxcuZXx7gk7LS1EzvEp37vYOPeXpHCTsJ/UYbVS27+3otiXtMD3sBv1O99if/sGrXIu9qM1zZeX1w0qQs3L0Bs0CCtxrBetvVct4WzxlINsekH0dw2Ddm5oM3yy0bBymyIeQhtG29sp33RIqwuO4ta6ExGQwGQdtZuBZF5Bt7fzdTiJun1QAAAABJRU5ErkJggg==&quot;"
                 alt="" class="avatar">
          </div>
          <div>
<!--            <span class="signature">{{ $t('暂未设置签名') }}</span>-->
            <div class="info"><span class="username">{{ $t('账户') }}: {{ $store.state.userInfo.username }}</span></div>
          </div>
        </div>
        <img src="/static/img/hudu.26088fcf.png" alt="" class="hudu">
      </div>
      <div class="topAmount">
        <div class="AmountMoney">
<!--          <span class="currency">VND</span>-->
          {{ $store.state.userInfo.balance }}
          <!--            <img @click="$parent.getUserInfoShowLoding()" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAMAAACelLz8AAAAXVBMVEUAAACpsMqpsMquuNKqscqrssupsMqosMqpsMqosMqpsMqpsMqpsMqpsMqqsMuqscuoscupscqoscuor8ioscqpssinsc2psMqqsMmqsMqpsMupsMmosMmmscipsMrAnmk1AAAAHnRSTlMA86cHwyiwhGtB+Orj29K3no9ZRjccFNXIvHp3Xi6KZiMMAAAA2klEQVQoz42SRxLDIAxFRTC49x7b3P+Y+UAYYIaF/0roqSEgp3k8alZ3w80pVpkpp6aISK5CZcITqSAm829uk9kM56JJj1N1bSbqGQxc1l7h9IHZCd+20ZFMARWw9mis01YlEsjaQrJKh5A3BYAj0iPoFbIdPErsBqgdeQJOLYZXqp0SjI8tMb20klICgj4ijSzk79BUeCTXMHzTHRw6o+l2eJCHu1WwGj+k6HR9AurXxSQOjy126cie/u8826oZfoA0pgw2mqlQOYUqGutN7YbfQ4c/eoyz8/wAG0gaU4TQX6QAAAAASUVORK5CYII=" alt="">-->
        </div>
        <div class="AmountBottom">
          <span class="AmountName">
            {{ $t('账户总资产') }}
            <img src="/static/image/new/mine/eye-icon.png" alt="">
          </span>
          <img src="/static/image/new/mine/visa-text.png" class="visa-img" alt="">
        </div>

      </div>
    </div>
    <div class="content">
      <div class="topContent">
        <div class="actionList1">

          <div @click="go('/vip2')" class="actionicon1" style="background-image: url('/static/image/new/mine/card-bg2.png')">
            <img src="/static/image/new/mine/card-icon1.png">
            <div class="title">{{ $t('VIP特权') }}</div>
          </div>
          <div @click="go('/inviter')" class="actionicon1" style="background-image: url('/static/image/new/mine/card-bg3.png')">
            <img src="/static/image/new/mine/card-icon2.png">
            <div class="title">{{ $t('邀请好友') }}</div>
          </div>

        </div>
        <div class="menu-list">
          <div class="menu-item" style="background-image: url('/static/image/new/mine/menu-bg-img1.png')" @click="$parent.goNav('/recharge')">
            <img src="/static/image/new/mine/menu-img1.png" alt="">
            <span>{{ $t('充值') }}</span>
          </div>
          <div class="menu-item" style="background-image: url('/static/image/new/mine/menu-bg-img2.png')" @click="$parent.goNav('/withdrawal')">
            <img src="/static/image/new/mine/menu-img2.png" alt="">
            <span>{{ $t('提现') }}</span>
          </div>
          <div class="menu-item" style="background-image: url('/static/image/new/mine/menu-bg-img3.png')" @click="$parent.goNav('/transfer')">
            <img src="/static/image/new/mine/menu-img3.png" alt="">
            <span>{{ $t('划转') }}</span>
          </div>
        </div>
        <div class="actionList">
          <div @click="go('/account')" class="actionicon">
            <img src="/static/image/new/mine/account-icon1.png">
            <div class="title">{{ $t('我的钱包') }}</div>
          </div>
          <div @click="go('/transRecord')" class="actionicon">
            <img src="/static/image/new/mine/account-icon2.png">
            <div class="title">{{ $t('账户明细') }}</div>
          </div>
          <div @click="go('/betRecord')" class="actionicon">
            <img src="/static/image/new/mine/account-icon3.png">
            <div class="title">{{ $t('投注记录') }}</div>
          </div>
          <div @click="go('/userCent')" class="actionicon">
            <img src="/static/image/new/mine/account-icon4.png">
            <div class="title">{{ $t('安全设置') }}</div>
          </div>
        </div>

      </div>
      <div class="refresh">
        <div class="refreshinner">
          <div class="person-list">
            <div class="person-list-p" @click="go('/iframepage')">
              <div class="person-list-p-left">
                <img src="/static/image/new/mine/menu-icon1.png" alt="">
                <span>{{ $t('我的等级') }}</span>
              </div>
              <div class="person-list-p-right">
                <span class="level_img"></span>
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">
              </div>
            </div>
            <div class="person-list-p" @click="go('/vip2')">
              <div class="person-list-p-left">
                <img src="/static/image/new/mine/menu-icon2.png" alt="">
                <span>{{ $t('VIP中心') }}</span>
              </div>
              <div class="person-list-p-right">
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">
              </div>
            </div>
            <!--           <div class="person-list-p" @click="go('/inviter')">-->
            <!--                <div class="person-list-p-left"><img-->
            <!--                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAABKVBMVEX4+fz///+zv9r////6+/3c4u6uutj///9rgrc7WqA+XKFCX6OhsNFFYqWIm8Wqt9Zed7Dm6vROaqlogLZherJXca5Sbavz9flUb6xKZ6dJZqZHZKYwg//j6PLN1edddrD3+f76+/3g5fC6xd6drM+bqs9mfbRSmP8Gav/q7fXH0OSgr9GLnceEl8NcdrBQa6pNaaiHuP8JbP/p7fSks9OYqM2Pocng7f/a6f9bnf9LlP9Djv8pgP/v8ffp7PTW3euottWSpMp/k8F4jb12i7xvhrk3V53m8P/k7/+hx/+Dtf94r/9hof86iv8dd/8Zdf8AXv/8/f7c4u7AyuG+yN+1wNuuu9ifrtB7kL8iRZS/2f+Wv/9opf8fef8Ob/8AVf8AT//s7/Wyvtpga9s5AAAAB3RSTlPy8vLm8vLy/EbT0gAAAf5JREFUOMvtlWlT2kAYgBdRN2xcoNnc4UYIIkKgQMshIFfVelartXf7/39EN4dZxiDwA/p8SWb2mWfyvjM7AeGQxzZYxvNpGECXbIEjXJDiNOUJIOQ8bscRC/NBdIMvO0LIE++RJB1Voi+pzFSNZBfFFi/fwyUoE01KLooFJGbhMmKomlsU95H4h51m2Osen06+EA987eLqqy8erhDfX9983Eh8lyidbyR+SJTqr4otVB04tQuzYyb6vU6ne+atQ2JT08U8PqnHkFL/3Wj8TFz+KDVurjPO1E+CQgVbVNokmoOjlDuI2TO7if6l2e19czcey2UKxcmQipW5gNXP8Jlbe5g6ZOQIL/DCDgCiJAky/pKDS4dRTgxBFkS0CwDBzUNc09WYv8d+w99juYglPL3j0BYA3DwP81VMo5/cw9OrX+csJxjtLIw7YmQE4dsjo6bLXvTs+ynLFcsQJtOuaJ+70Ykd9Thu05x+otDXN3Em2lFc0+SR/3UiVjGhSwuITlTF06GTqxiCpbcyMCCyqFpIDR/sr+PsXFD0ommsarKky5ZWsHNBkUU1XtcwP3NzQZGRao3H7TyEK0XGf9EXHzYTyfzvOlERI1tgmxjcYI14J6Bdegv5Gnls7r1Oc1+0rB0QOojzOoqsAmHUDAEIB1FCuFWQGb32zu8DrIEq4X9Nol0/980wZwAAAABJRU5ErkJggg=="-->
            <!--                        alt=""><span>邀请好友</span></div>-->
            <!--                <div class="person-list-p-right"><span class="textRight">{{ $t('推荐送礼金') }}</span><img-->
            <!--                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">-->
            <!--                </div>-->
            <!--            </div>-->
            <div class="person-list-p" @click="go('/message')">
              <div class="person-list-p-left">
                <img src="/static/image/new/mine/menu-icon3.png" alt="">
                <span>{{ $t('官方公告') }}</span>
              </div>
              <div class="person-list-p-right">
                <span class="textRight">{{ $t('邀请好友') }}，{{ $t('坐收盈利') }}</span>
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">
              </div>
            </div>
            <div class="person-list-p" @click="go('/applyagent')">
              <div class="person-list-p-left">
                <img src="/static/image/new/mine/menu-icon4.png" alt="">
                <span>{{ $t('合营计划') }}</span>
              </div>
              <div class="person-list-p-right">
                <span class="textRight">{{ $t('加入我们') }}，{{ $t('月入百万') }}</span>
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">
              </div>
            </div>
            <!--            <div class="person-list-p">-->
            <!--                <div class="person-list-p-left"><img-->
            <!--                        src="/static/img/enter.03a1069b.png"-->
            <!--                        alt=""><span>{{ $t('NG扑克') }}</span></div>-->
            <!--                <div class="person-list-p-right"><img-->
            <!--                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">-->
            <!--                </div>-->
            <!--            </div>-->
            <div class="person-list-p" @click="go('/activity')">
              <div class="person-list-p-left">
                <img src="/static/image/new/mine/menu-icon5.png" alt="">
                <span>{{ $t('活动中心') }}</span>
              </div>
              <div class="person-list-p-right">
                <span class="textRight">{{ $t('平台优惠回馈活动') }}</span>
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">
              </div>
            </div>
            <div class="person-list-p" @click="go('/profit-loss')">
              <div class="person-list-p-left">
                <img src="/static/image/new/mine/menu-icon6.png" alt="">
                <span>{{ $t('输赢比例') }}</span>
              </div>
              <div class="person-list-p-right">
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">
              </div>
            </div>
            <div class="person-list-p" @click="go('/userCent')">
              <div class="person-list-p-left">
                <img src="/static/image/new/mine/menu-icon7.png" alt="">
                <span>{{ $t('功能设置') }}</span>
              </div>
              <div class="person-list-p-right">
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">
              </div>

            </div>
            <div class="person-list-p" @click="go('/cashback-rates')">
              <div class="person-list-p-left">
                <img src="/static/image/new/mine/menu-icon8.png" alt="">
                <span>{{ $t('反水比例') }}</span>
              </div>
              <div class="person-list-p-right">
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">
              </div>
            </div>
            <div class="person-list-p" @click="go('/fanshui')">
              <div class="person-list-p-left">
                <img src="/static/image/new/mine/menu-icon8.png" alt="">
                <span>{{ $t('反水中心') }}</span>
              </div>
              <div class="person-list-p-right">
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">
              </div>
            </div>
            <div class="person-list-p" @click="go('/agent-index')" v-if="$store.state.userInfo.isagent == 1">
              <!--            <div class="person-list-p" @click="go('/agent-index')">-->
              <div class="person-list-p-left">
                <img src="/static/image/new/mine/menu-icon9.png" alt="">
                <span>{{ $t('代理系统') }}</span>
              </div>
              <div class="person-list-p-right">
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">
              </div>
            </div>
            <div class="person-list-p" @click="go('/language-selection')">
              <div class="person-list-p-left">
                <img src="/static/image/new/mine/menu-icon9.png" alt="">
                <span>{{ $t('语言') }}</span>
              </div>
              <div class="person-list-p-right">
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">
              </div>
            </div>

            <div class="person-list-p" @click="go('/password')">
              <div class="person-list-p-left">
                <img src="/static/image/new/mine/menu-icon10.png" alt="">
                <span>{{ $t('修改登录密码') }}</span></div>
              <div class="person-list-p-right"><img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaBAMAAAB1IXBvAAAALVBMVEUAAACsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7qsr7r0zr/9AAAADnRSTlMA6nqL4kI03jdAhMm/U7FtruIAAABGSURBVAjXY9AJYAADuTIIve5JA5hmfucGEbDDEHieABXwwCXwBE1g3XMIrQehmd6JQrgPJ+DlBkC4kni4DHIQxQyrL4ApAE//ID6UipmmAAAAAElFTkSuQmCC">
              </div>

            </div>
          </div>
        </div>
        <div style="height: 150px; width: 100%;"></div>
      </div>
    </div>


  </div>
</template>
<script>
import {translateText} from "../../common/utils";

export default {
    name: 'mine',
    data() {
      return {
        activitylistList: [],
        // imgBase: 'https://youxi3.web3bc.com/uploads/',
        imgBase: 'https://api.n778.com/uploads/',
        bfNum: 0,
        vipLis: [],
        userInfo: {}
      };
    },
    created() {
      let that = this;
      this.userInfo = this.$store.state.userInfo
      that.activitylist();
      that.uservip();
    },
    methods: {
      go(s){
        this.$router.push(s)
      },
      onchangemd(e) {
        let that = this;

        console.log(e.target.files); //这个就是选中文件信息
        let formdata = new FormData();
        Array.from(e.target.files).map(item => {
          console.log(item);
          formdata.append('file', item); //将每一个文件图片都加进formdata
        });
        //  axios.post("接口地址", formdata).then(res => { console.log(res) })
        that.$parent.showLoading();

        that.$apiFun.post('/api/uploadimg', formdata).then(res => {
          that.$parent.hideLoading();

          that.$parent.getUserInfoShowLoding();
        });
      },
      async showTost(type = 0, title) {
        const message = await translateText([title]);
        this.$parent.showTost(type, message[0]);
      },
      uservip() {
        let that = this;
        that.$parent.showLoading();
        that.$apiFun
          .post('/api/uservip', {})
          .then(res => {
            if (res.code != 200) {
              that.showTost(0, res.message);
            }
            if (res.code == 200) {
              that.vipLis = res.data;
              that.getbfNum();
            }
            that.$parent.hideLoading();
          })
          .catch(res => {
            that.$parent.hideLoading();
          });
      },
      getbfNum() {
        let that = this;
        let num = 0; //当前vip充值钱
        let vip = that.$store.state.userInfo.vip * 1; //当前vip等级
        that.vipLis.forEach((el, index) => {
          console.log();
          if (index == vip) {
            num = el.recharge * 1;
          }
        });
        let userMey = that.$store.state.userInfo.paysum * 1;
        let bfNum = userMey == 0 || num == 0 ? 0 : Math.round((userMey / num) * 100);
        that.bfNum = bfNum > 100 ? 100 : bfNum;
        console.log(111);
      },
      transall() {
        let that = this;
        that.$parent.showLoading();
        that.$apiFun
          .post('/api/transall', {})
          .then(res => {
            that.showTost(0, res.message);
            that.$parent.getUserInfoShowLoding();
            that.$parent.hideLoading();
          })
          .catch(res => {
            that.$parent.hideLoading();
          });
      },
      activitylist() {
        let that = this;
        let info = that.actType == '' ? {} : { type: that.actType };
        that.$parent.showLoading();
        that.$apiFun.post('/api/activitylist', info).then(res => {
          console.log(res);
          if (res.code !== 200) {
            that.showTost(0, res.message);
          }
          if (res.code === 200) {
            that.activitylistList = res.data.data;
          }
          that.$parent.hideLoading();
        });
      },
    },
    mounted() {
      let that = this;
    },
    updated() {
      let that = this;
    },
    beforeDestroy() {},
  };
</script>
<style lang="scss" scoped>
.person {
  background-color: #000;
  color: #fff;
  font-family: PingFang SC;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  padding-bottom: 1.79rem;  // 底部导航栏高度
  right: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .content {
    flex: 1;
    overflow: auto;
  }
}
.person .topContent .topArea {
  background-size:100% 100%
}
.person .topContent .topArea .head_area {
  height:1.33333rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:justify;
  -webkit-justify-content:space-between;
  -ms-flex-pack:justify;
  justify-content:space-between;
  padding-left:.48rem;
  padding-right:.48rem;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  box-sizing:border-box;
  z-index:1
}
.person .topContent .topArea .head_area .leftImg {
  -webkit-box-flex:1;
  -webkit-flex:1;
  -ms-flex:1;
  flex:1;
  text-align:left
}
.person .topContent .topArea .head_area .leftImg .top_back {
  width:.85333rem;
  height:.85333rem
}
.person .topContent .topArea .head_area .head_text {
  font-size:.48rem;
  font-weight:bold;
  color:#fff;
  text-align:center;
}
.person .topContent .topArea .head_area .right_menu {
  font-size:.48rem;
  font-weight:700;
  color:#1d2548;
  -webkit-box-flex:1;
  -webkit-flex:1;
  -ms-flex:1;
  flex:1;
  text-align:right
}
.person .topContent .topArea .head_area .right_menu .right_menu_img {
  width:.75rem;
  height:.75rem
}
.person .topContent .topArea .part1 {
  padding-left:.48rem;
  padding-right:.4rem;
  margin-top: 0.5rem;
}
.person .topContent .topArea .part1,
.person .topContent .topArea .part1 .avatarBox {
  display:flex;
  align-items:center;
  z-index:999
}
.person .topContent .topArea .part1 .avatarBox {
  width:1.6rem;
  height:1.6rem;
  display: flex;
  justify-content:center;
  border-radius:50%;
}
.person .topContent .topArea .part1 .avatarBox .avatar {
  width:1.6rem;
  height:1.6rem;
  border-radius:50%;
}
.person .topContent .topArea .part1 .signature {
  font-size:.43rem;
  font-weight:500;
  margin-top: -0.5rem;
  color:#fff;
  padding-left: .32rem;
}
.person .topContent .topArea .part1 .info {
  font-size: 0.32rem;
  padding-left: .32rem;
}
.person .topContent .topArea .part1 .info .username {
  font-size: .43rem;
}
.person .topContent .topArea .hudu {
  height:1.17333rem;
  background-size:100% 100%;
  margin-top:-.53333rem;
  z-index:8
}
.person .topContent .topArea .part2 {
  margin-top:-.48rem;
  padding-left:.48rem;
  padding-right:.42667rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:justify;
  -webkit-justify-content:space-between;
  -ms-flex-pack:justify;
  justify-content:space-between;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.person .topContent .topArea .part2 .nickname {
  font-size:.48rem;
  font-family:PingFang SC;
  font-weight:500;
  color:#0b1028
}
.person .topContent .topArea .part2 .rightSpan {
  display:flex;
  align-items:center;
  width: 100%;
}
.person .topContent .topArea .part2 .rightSpan .uid,
.person .topContent .topArea .part2 .rightSpan .username {
  border-radius:.10667rem;
  justify-content:center;
  font-size:.29333rem;
  font-weight:500;
  color:#fcfcfc;
}
.person .topContent .actionList,
.person .topContent .topArea .part2 .rightSpan .uid,
.person .topContent .topArea .part2 .rightSpan .username {
  display:flex;

  align-items:center
}
person .topContent .actionList1,
.person .topContent .topArea .part2 .rightSpan .uid,
.person .topContent .topArea .part2 .rightSpan .username {
  display:flex;
  font-size: 0.32rem;
  margin-top: -1.5rem;
  align-items:center;
}
.person .topContent .actionList {
  width:9.2rem;
  //height:1.16rem;
  border-radius:.26667rem;
  margin: .37rem auto;
  transform: translateY(-1px);
  justify-content: space-between;
}
.person .topContent .actionList1,
.person .topContent .topArea .part2 .rightSpan .uid,
.person .topContent .topArea .part2 .rightSpan .username {

  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.person .topContent .actionList1 {
  padding: 0 .4rem;
  display: flex;
  justify-content: space-between;
}
.person .topContent .actionList .actionicon {
  display:flex;
  flex-direction:column;
  align-items:center;
  //flex:1;
  max-width: 25%;
}
.person .topContent .actionList1 .actionicon1 {
  display:flex;
  align-items: center;
  width: 4.48rem;
  height: 1.44rem;
  background-size: 100% 100%;
  padding: 0 .32rem;
}
.person .topContent .actionList .actionicon img {
  width:1.31rem;
  height:1.31rem;
}
.person .topContent .actionList1 .actionicon1 img {
  width: .64rem;
  height: .64rem;
  margin-right: .16rem;
}
.person {
  .topContent {
    .menu-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      z-index: 2;
      padding: .37rem .4rem 0;
      .menu-item {
        width: 2.88rem;
        height: 1.44rem;
        position: relative;
        display: flex;
        align-items: center;
        padding: 0 .26rem;
        background-size: 100% 100%;
        img {
          width: .64rem;
          margin-right: .16rem;
        }
        span {
          font-size: 0.37rem;
          position: relative;
          z-index: 2;
          flex-shrink: 0;
        }
      }
    }
  }
}


.person .topContent .actionList .actionicon .title {
  font-size:.32rem;
  font-weight:500;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #999999;
  width: 100%;
  margin-top: .16rem;

}
.person .topContent .actionList1 .actionicon1 .title {
  color: #fff;
  font-weight: bold;
  font-size: 0.37rem;
}
.person .topContent .topAmount {
  position: relative;
  border-radius:.27rem;

  background-image: url("/static/image/new/mine/card-bg1.png");
  background-size: 100% 100%;
  margin: -0.1rem .4rem .37rem;
  height: 2.88rem;
  padding: 0.42rem .4rem .27rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .AmountMoney {
    font-family: Gilroy;
    font-weight: bold;
    font-size: 0.64rem;
    .currency {
      font-size: 0.53rem;
      font-weight: 500;
      margin-right: .1rem;
    }
  }
  .AmountBottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .AmountName {
      display: flex;
      align-items: center;
      img {
        width: 0.43rem;
        height: 0.43rem;
        margin: 0 .16rem;
      }
    }
    .visa-img {
      width: 1.32rem;
    }
  }
}


.person .userInfo {
  width:100%;
  background:#fff;
  padding:.4rem .4rem .53333rem .4rem;
  box-sizing:border-box;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  border-bottom:.02667rem solid #d7ddeb
}
.person .userInfo .info_left {
  width:1.6rem;
  height:1.6rem;
  border-radius:50%;
  overflow:hidden
}
.person .userInfo .info_left img {
  width:100%
}
.person .userInfo .info_content {
  -webkit-box-flex:1;
  -webkit-flex:1;
  -ms-flex:1;
  flex:1;
  height:100%;
  padding-left:.4rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-orient:vertical;
  -webkit-box-direction:normal;
  -webkit-flex-direction:column;
  -ms-flex-direction:column;
  flex-direction:column
}
.nickname {
  opacity: 0 !important;
}
.person .userInfo .info_content .lable {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex
}
.person .userInfo .info_content .lable>span {
  height:.58667rem;
  line-height:.58667rem;
  display:inline-block;
  background-color:#f2f4fd;
  border-radius:.10667rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  margin-right:.16rem;
  color:#5b6897;
  font-size:.29333rem;
  padding-left:.24rem;
  padding-right:.24rem
}
.person .userInfo .info_content>:last-child {
  color:#6072a5
}
.person .userInfo>img {
  width:.16rem;
  height:.26667rem
}
.person .person-list {
  padding: 0 .4rem;
}
.person .level_box {
  width:100%;
  height:1.33333rem;
  margin-top:.26667rem;
  padding:0 .4rem;
  box-sizing:border-box;
  background:#fff;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.person .level_box>:first-child {
  width:.53rem;
  height:.53rem;
  margin-right:.27rem
}
.person .level_box span {
  font-size:.42667rem;
  font-family:PingFang SC;
  font-weight:500
}
.person .level_box .level_img {
  -webkit-box-flex:1;
  -webkit-flex:1;
  -ms-flex:1;
  flex:1;
  text-align:right;
  padding-right:.26667rem
}
.person .level_box .level_img img {
  width:.4rem;
  height:.4rem;
  margin:0 .02667rem
}
.person .level_box>:last-child {
  width:.16rem;
  height:.26667rem
}
.person #hyjhtre {
  display:inline-block;
  width:.42667rem;
  height:.42667rem;
  float:none;
  margin-left:.4rem;
  margin-top:-.05333rem;
  vertical-align:middle;
  margin-right:.36rem
}
.person .person-head {
  height:5.65333rem;
  width:100%;
  background-size:cover;
  text-align:center;
  position:relative
}
.person .person-head .leftboxsdiv {
  float:left;
  width:100%;
  height:1.6rem;
  position:absolute;
  left:0;
  bottom:-.8rem;
  z-index:200
}
.person .person-head .leftboxsdiv .person-head-img {
  float:left;
  width:1.6rem;
  height:1.6rem;
  border-radius:50%;
  margin-left:.26667rem
}
.person .person-head .leftboxsdiv .rightdivcont {
  float:left;
  width:6.66667rem;
  margin-left:.26667rem
}
.person .person-head .leftboxsdiv .rightdivcont .person-nickname {
  height:.8rem;
  font-size:.42667rem;
  font-weight:600;
  color:#fff
}
.person .person-head .leftboxsdiv .rightdivcont .person-nickname,
.person .person-head .leftboxsdiv .rightdivcont .person-vip {
  float:left;
  width:100%;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:start;
  -webkit-justify-content:flex-start;
  -ms-flex-pack:start;
  justify-content:flex-start;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.person .person-head .leftboxsdiv .rightdivcont .person-vip {
  height:.64rem;
  font-size:.32rem;
  color:#999
}
.person .person-head .leftboxsdiv .rightdivcont .person-vip img {
  height:.42667rem;
  width:auto;
  margin-right:.26667rem
}
.person .person-list-p {
  justify-content:space-between;
  height:1.17rem;
  padding: 0 .27rem;
  font-size:.37rem;
  font-weight:500;
  background: rgba(255, 255, 255, 0.10);
  border: 0.03rem solid rgba(255, 255, 255, 0.10);
  margin-bottom: .27rem;
  border-radius: .19rem;
}
.person .person-list-p,
.person .person-list-p .person-list-p-left {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.person .person-list-p .person-list-p-left>:first-child {
  width:.58667rem;
  height:.58667rem
}
.person .person-list-p .person-list-p-left span {
  margin-left:.4rem
}
.person .person-list-p .person-list-p-left span .vipNum {
  color:red
}
.person .person-list-p .person-list-p-right {
  -webkit-box-flex:1;
  -webkit-flex:1;
  -ms-flex:1;
  flex:1;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  -webkit-box-pack:end;
  -webkit-justify-content:flex-end;
  -ms-flex-pack:end;
  justify-content:flex-end
}
.person .person-list-p .person-list-p-right>:last-child {
  width:.16rem;
  height:.26667rem
}
.person .person-list-p .person-list-p-right .textRight {
  text-align:right;
  color: #999999;
  font-size:.32rem;
  font-weight:Medium;
  margin-right:.37333rem;
  width: 75%;
}
.person .person-icon {
  width:.58667rem;
  height:.58667rem;
  display:inline-block;
  background-size:cover;
  background-position-y:0;
  position:relative;
  top:.08rem;
  margin:0 .4rem
}
.person .porcessct {
  width:5.33333rem;
  height:.34667rem;
  background:#fff;
  border-radius:.17333rem;
  margin:.26667rem 0 0 2.34667rem;
  overflow:hidden;
  float:left;
  position:relative
}
.person .porcessct .datadiv {
  width:100%;
  height:100%;
  position:absolute;
  z-index:300;
  top:0;
  left:0;
  font-size:.32rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  -webkit-transform:scale(.67);
  -ms-transform:scale(.67);
  transform:scale(.67)
}
.person .porcessct .procees {
  width:20%;
  height:.34667rem;
  background:#62b6f8;
  position:absolute;
  top:0;
  left:0;
  z-index:200
}
.person .right_notice {
  position:fixed;
  top:4.8rem;
  right:0;
  z-index:300
}
.person .right_notice .notice_item {
  min-width:4rem;
  height:1.33333rem;
  padding:0 .26667rem;
  margin-bottom:.26667rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  background:#fff;
  box-shadow:0 0 .26667rem 0 rgba(45,55,99,.25);
  border-radius:.66667rem 0 0 .66667rem;
  -webkit-transition:all .3s linear;
  transition:all .3s linear
}
.person .right_notice .notice_item>:first-child {
  width:.16rem;
  height:.26667rem
}
.person .right_notice .notice_item>:nth-child(2) {
  width:1.04rem;
  height:1.04rem;
  margin:.26667rem
}
.person .right_notice .notice_item>:nth-child(3) {
  color:#1d2548;
  font-size:.32rem;
  font-weight:700
}
.person .hiddenRight {
  -webkit-transform:translateX(0)!important;
  -ms-transform:translateX(0)!important;
  transform:translateX(0)!important
}
.person .hiddenRight>:first-child {
  -webkit-transform:rotate(0deg)!important;
  -ms-transform:rotate(0deg)!important;
  transform:rotate(0deg)!important
}
.right_notice {
  position:fixed;
  top:4.8rem;
  right:0;
  z-index:300
}
.right_notice .notice_item {
  min-width:4rem;
  height:1.33333rem;
  padding:0 .26667rem;
  margin-bottom:.26667rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  background:#fff;
  box-shadow:0 0 .26667rem 0 rgba(45,55,99,.25);
  border-radius:.66667rem 0 0 .66667rem;
  -webkit-transform:translateX(2.58667rem);
  -ms-transform:translateX(2.58667rem);
  transform:translateX(2.58667rem);
  -webkit-transition:all .3s linear;
  transition:all .3s linear
}
.right_notice .notice_item>:first-child {
  width:.16rem;
  height:.26667rem;
  -webkit-transform:rotate(180deg);
  -ms-transform:rotate(180deg);
  transform:rotate(180deg)
}
.right_notice .notice_item>:nth-child(2) {
  width:1.04rem;
  height:1.04rem;
  margin:.26667rem
}
.right_notice .notice_item>:nth-child(3) {
  color:#1d2548;
  font-size:.32rem;
  font-weight:700
}
.right_notice .notice_item .cutDown {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-orient:vertical;
  -webkit-box-direction:normal;
  -webkit-flex-direction:column;
  -ms-flex-direction:column;
  flex-direction:column;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  padding-top:.05333rem
}
.right_notice .notice_item .cutDown .tittleGif {
  width:2.24rem;
  height:.32rem
}
.right_notice .notice_item .cutDown .timeText {
  font-size:.32rem;
  font-family:PingFang SC;
  font-weight:500;
  color:#007aff;
  margin-top:.10667rem
}
.actionCenter[data-v-7bf83c52] {
  text-align:center
}
.actionCenter .head[data-v-7bf83c52] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  width:100%;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  position:relative;
  background:#fff;
  border-bottom:.02667rem solid #e7eaf3
}
.actionCenter .head[data-v-7bf83c52]>:first-child {
  width:.85333rem;
  height:.85333rem;
  margin-left:.26667rem;
  position:absolute;
  left:0;
  top:.10667rem
}
.actionCenter .head span[data-v-7bf83c52] {
  font-size:.48rem;
  font-family:PingFang SC;
  font-weight:700;
  color:#1d2548
}
.actionCenter .navslist[data-v-7bf83c52] {
  width:100%;
  background:#fff
}
.actionCenter .navslist[data-v-7bf83c52],
.actionCenter .navslist div[data-v-7bf83c52] {
  height:1.33333rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex
}
.actionCenter .navslist div[data-v-7bf83c52] {
  -webkit-box-flex:1;
  -webkit-flex:1;
  -ms-flex:1;
  flex:1;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  color:#2f3242;
  font-size:.37333rem
}
.actionCenter .navslist .divac[data-v-7bf83c52] {
  color:#4f8dfe
}
.actionCenter .action-list[data-v-7bf83c52] {
  width:100%;
  height:calc(100% - 2.50667rem);
  overflow-x:hidden;
  overflow-y:auto
}
.actionCenter .action-list .action-card[data-v-7bf83c52] {
  margin:0 .26667rem;
  padding:.26667rem 0;
  background:#fff;
  border-radius:.13333rem
}
.actionCenter .action-list .action-card img[data-v-7bf83c52] {
  width:8.93333rem;
  height:4.26667rem
}
.actionCenter .action-list .action-card .action-p1[data-v-7bf83c52] {
  font-size:.37333rem;
  color:#2f3242;
  text-indent:.26667rem;
  margin:0 0;
  text-align:left;
  margin-top:.32rem
}
.actionCenter .action-list .action-card .action-p2[data-v-7bf83c52] {
  font-size:.32rem;
  color:#575c73;
  text-indent:.26667rem;
  margin:0 0;
  text-align:left;
  margin-top:.13333rem
}
.regist[data-v-24d6c286] {
  width:100%
}
.hongbaoDetails .botline div[data-v-24d6c286],
.hongbaoDetails .replenishment .botline div[data-v-24d6c286],
.hongbaoDetails .replenishment .sumbtns[data-v-24d6c286],
.textctr[data-v-24d6c286] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.hongbaoDetails .replenishment .inputline div[data-v-24d6c286],
.textrtr[data-v-24d6c286] {
  -webkit-box-pack:start;
  -webkit-justify-content:flex-start;
  -ms-flex-pack:start;
  justify-content:flex-start
}
.hongbaoDetails .replenishment .inputline div[data-v-24d6c286],
.textlt[data-v-24d6c286],
.textrtr[data-v-24d6c286] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.textlt[data-v-24d6c286] {
  -webkit-box-pack:end;
  -webkit-justify-content:flex-end;
  -ms-flex-pack:end;
  justify-content:flex-end
}
.hongbaoDetails[data-v-24d6c286] {
  height:100%;
  background-color:#fff;
  background-image:url(/static/img/zcdl_bj.dd3e65d0.png);
  background-repeat:no-repeat;
  background-size:100% auto;
  float:left;
  width:100%;
  box-sizing:border-box
}
.hongbaoDetails .gbline[data-v-24d6c286] {
  position:fixed;
  right:.26667rem;
  top:.26667rem;
  width:1.06667rem
}
.hongbaoDetails .loglines[data-v-24d6c286] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  width:100%;
  height:2.13333rem;
  margin-top:1.73333rem;
  margin-bottom:1.12rem
}
.hongbaoDetails .loglines img[data-v-24d6c286] {
  width:4rem
}
.hongbaoDetails .lginner[data-v-24d6c286] {
  float:left;
  width:100%;
  box-sizing:border-box;
  padding:0 1.06667rem
}
.hongbaoDetails .lginner .gbline[data-v-24d6c286] {
  position:fixed;
  right:.26667rem;
  top:.26667rem;
  width:.53333rem;
  height:.53333rem
}
.hongbaoDetails .getBack[data-v-24d6c286] {
  font-size:.4rem;
  text-align:center
}
.hongbaoDetails .sbac[data-v-24d6c286] {
  opacity:1
}
.hongbaoDetails .botline[data-v-24d6c286] {
  float:left;
  height:.37333rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  margin-top:.53333rem
}
.hongbaoDetails .botline div[data-v-24d6c286] {
  -webkit-box-flex:1;
  -webkit-flex:1;
  -ms-flex:1;
  flex:1;
  height:.37333rem;
  color:#424653;
  font-size:.37333rem
}
.hongbaoDetails .replenishment[data-v-24d6c286] {
  padding:0 1.01333rem
}
.hongbaoDetails .replenishment .inputline[data-v-24d6c286]:after {
  content:".";
  height:0;
  visibility:hidden;
  display:block;
  clear:both
}
.hongbaoDetails .replenishment .inputline[data-v-24d6c286] {
  float:left;
  width:100%;
  height:1.2rem;
  background:#fff;
  border-radius:.26667rem;
  box-sizing:border-box;
  margin-top:.26667rem;
  z-index:3;
  position:relative
}
.hongbaoDetails .replenishment .inputline input[data-v-24d6c286] {
  width:6.93333rem;
  padding-left:.4rem;
  float:left;
  color:#1d2548;
  text-align:left;
  line-height:1.12rem;
  font-size:.37333rem;
  border:none;
  outline:none;
  left:.74667rem;
  top:.05333rem;
  position:absolute;
  z-index:2;
  background:#fff
}
.hongbaoDetails .replenishment .inputline div[data-v-24d6c286] {
  width:50%;
  height:1.2rem;
  float:left;
  color:red;
  position:absolute;
  z-index:1;
  left:1.12rem;
  padding-left:0
}
.hongbaoDetails .replenishment .inputline .eye[data-v-24d6c286] {
  float:right;
  width:.42667rem;
  height:.21333rem;
  margin-top:.42667rem;
  margin-right:.4rem;
  position:absolute;
  z-index:3;
  right:0
}
.hongbaoDetails .replenishment .inputline .iconImg[data-v-24d6c286] {
  float:left;
  width:.34667rem;
  height:.42667rem;
  margin-top:.42667rem;
  margin-right:.4rem;
  margin-left:.4rem;
  position:absolute;
  z-index:3;
  left:0
}
.hongbaoDetails .replenishment .inputline .yzm[data-v-24d6c286] {
  width:1.89333rem;
  height:.66667rem;
  border:.02667rem solid #e3e4ea;
  float:right;
  margin-top:.21333rem;
  margin-right:.4rem;
  right:0;
  position:absolute;
  z-index:3
}
.hongbaoDetails .replenishment .sumbtns[data-v-24d6c286] {
  float:left;
  height:1.2rem;
  color:#fff;
  margin-top:.8rem;
  font-size:.45333rem;
  font-weight:700;
  opacity:.7
}
.hongbaoDetails .replenishment .sumbtns .van-button--block[data-v-24d6c286],
.hongbaoDetails .replenishment .sumbtns[data-v-24d6c286] {
  width:100%;
  background-color:#237bff;
  border-radius:.21333rem
}
.hongbaoDetails .replenishment .sbac[data-v-24d6c286] {
  opacity:1
}
.hongbaoDetails .replenishment .botline[data-v-24d6c286] {
  float:left;
  width:100%;
  height:.37333rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  margin-top:.53333rem
}
.hongbaoDetails .replenishment .botline div[data-v-24d6c286] {
  -webkit-box-flex:1;
  -webkit-flex:1;
  -ms-flex:1;
  flex:1;
  height:.37333rem;
  color:#424653;
  font-size:.37333rem
}
.Login-window[data-v-a2119fda] {
  width:100%;
  height:100%
}
.loginwindow .LoginSquare .botline div[data-v-a2119fda],
.loginwindow .LoginSquare .confirm .sumbtns[data-v-a2119fda],
.textctr[data-v-a2119fda] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.loginwindow .LoginSquare .inputline div[data-v-a2119fda],
.textrtr[data-v-a2119fda] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:start;
  -webkit-justify-content:flex-start;
  -ms-flex-pack:start;
  justify-content:flex-start;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.loginwindow .LoginSquare .oplines>div[data-v-a2119fda]:nth-child(2),
.textlt[data-v-a2119fda] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:end;
  -webkit-justify-content:flex-end;
  -ms-flex-pack:end;
  justify-content:flex-end;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.loginwindow[data-v-a2119fda] {
  width:100%;
  height:100%;
  background-color:#fff;
  background-image:url(/static/img/topss1.dd3e65d0.png);
  background-repeat:no-repeat;
  background-size:100% auto
}
.loginwindow .lginner[data-v-a2119fda] {
  float:left;
  width:100%;
  box-sizing:border-box;
  padding:0 1.06667rem
}
.loginwindow .lginner .gbline[data-v-a2119fda] {
  position:fixed;
  right:.26667rem;
  top:.26667rem;
  width:1.06667rem
}
.loginwindow .loglines[data-v-a2119fda] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  width:100%;
  height:2.13333rem;
  margin-top:1.73333rem;
  margin-bottom:1.12rem
}
.loginwindow .loglines img[data-v-a2119fda] {
  width:3.49333rem
}
.loginwindow .loglines div[data-v-a2119fda] {
  width:5.38667rem;
  height:1.38667rem;
  font-size:.61333rem;
  font-weight:700;
  margin-top:.10667rem;
  float:left;
  line-height:.72rem;
  margin-left:.56rem
}
.loginwindow .LoginSquare .inputline[data-v-a2119fda] {
  float:left;
  width:100%;
  height:1.2rem;
  background:#fff;
  border-radius:.26667rem;
  box-sizing:border-box;
  margin-top:.26667rem;
  position:relative
}
.loginwindow .LoginSquare .inputline input[data-v-a2119fda] {
  width:6.93333rem;
  height:1.2rem;
  padding-left:.4rem;
  float:left;
  color:#1d2548;
  text-align:left;
  height:45px;
  font-size:.37333rem;
  border:none;
  outline:none;
  left:0;
  top:0;
  position:absolute;
  z-index:2;
  background:#fff;
  border-radius:.26667rem
}
.loginwindow .LoginSquare .inputline div[data-v-a2119fda] {
  width:50%;
  height:1.12rem;
  float:left;
  color:red;
  position:absolute;
  z-index:1;
  right:0;
  background-color:#fff;
  border-radius:.26667rem
}
.loginwindow .LoginSquare .inputline .eye[data-v-a2119fda] {
  float:right;
  width:.42667rem;
  height:.21333rem;
  margin-top:.42667rem;
  margin-right:.4rem;
  position:absolute;
  z-index:3;
  right:0
}
.loginwindow .LoginSquare .inputline .yzm[data-v-a2119fda] {
  width:1.89333rem;
  height:.66667rem;
  border:.02667rem solid #e3e4ea;
  float:right;
  margin-top:.21333rem;
  margin-right:.4rem;
  right:0;
  position:absolute;
  z-index:3
}
.loginwindow .LoginSquare .confirm[data-v-a2119fda] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center
}
.loginwindow .LoginSquare .confirm .sumbtns[data-v-a2119fda] {
  float:left;
  height:1.2rem;
  color:#fff;
  width:5.33333rem;
  background-color:#237bff;
  border-radius:.21333rem;
  margin-top:.8rem;
  font-size:.45333rem;
  font-weight:700;
  opacity:.7
}
.loginwindow .LoginSquare .confirm .sbac[data-v-a2119fda] {
  opacity:1
}
.loginwindow .LoginSquare .botline[data-v-a2119fda] {
  float:left;
  width:100%;
  height:.37333rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  margin-top:.53333rem
}
.loginwindow .LoginSquare .botline div[data-v-a2119fda] {
  -webkit-box-flex:1;
  -webkit-flex:1;
  -ms-flex:1;
  flex:1;
  height:.37333rem;
  color:#424653;
  font-size:.37333rem
}
.loginwindow .LoginSquare .oplines[data-v-a2119fda] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:justify;
  -webkit-justify-content:space-between;
  -ms-flex-pack:justify;
  justify-content:space-between;
  width:100%;
  padding-top:.77333rem;
  color:#1d2548;
  font-size:.4rem;
  font-family:PingFang SC;
  font-weight:500
}
.loginwindow .LoginSquare .oplines>div .van-checkbox__icon[data-v-a2119fda] {
  font-size:.34667rem;
  height:.34667rem;
  line-height:.34667rem
}
.loginwindow .LoginSquare .oplines>div .van-icon[data-v-a2119fda] {
  width:.34667rem;
  height:.34667rem;
  border-radius:.08rem
}
.loginwindow .LoginSquare .oplines>div .van-checkbox__label[data-v-a2119fda] {
  height:.34667rem;
  line-height:.34667rem
}
.loginwindow .LoginSquare .oplines>div .van-checkbox__icon--checked .van-icon[data-v-a2119fda] {
  background-color:#1989fa
}
.loginwindow .LoginSquare .oplines .ltbox[data-v-a2119fda] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.loginwindow .LoginSquare .oplines .ltbox>img[data-v-a2119fda] {
  margin-right:.08rem;
  width:.85333rem;
  height:.48rem
}
.topIndex[data-v-4f04d936] {
  z-index:999!important
}
.index-container[data-v-4f04d936] {
  max-width:10rem;
  margin:0 auto
}
.index-container .spgifuss[data-v-4f04d936] {
  position:fixed;
  bottom:1.7rem;
  right:.1rem;
  width:1.5rem;
  height:1.5rem
}
.index-container .hbpopclass[data-v-4f04d936] {
  float:left;
  width:100%;
  height:100%;
  background:transparent;
  z-index:200
}
.index-container .hbpopclass .hbcontentsl[data-v-4f04d936] {
  width:9.86667rem;
  height:12.56rem;
  background:url(/static/img/bgimg.a6fc96be.png) no-repeat;
  background-size:100% 100%;
  margin:0 auto;
  position:relative;
  top:50%;
  -webkit-transform:translateY(-50%);
  -ms-transform:translateY(-50%);
  transform:translateY(-50%)
}
.index-container .hbpopclass .hbcontentsl .hongbaobtncont[data-v-4f04d936] {
  float:left;
  width:5.52rem;
  height:7.33333rem;
  margin:2.93333rem 0 0 2.13333rem;
  overflow-y:scroll
}
.index-container .hbpopclass .hbcontentsl .hongbaobtncont .hongbaobtncontinner[data-v-4f04d936] {
  float:left;
  width:100%
}
.index-container .hbpopclass .hbcontentsl .hongbaobtncont .hongbaobtncontinner .hbyanshi[data-v-4f04d936] {
  float:left;
  width:5.52rem;
  height:2.18667rem;
  margin-top:.08rem
}
.index-container .hbpopclass .hbcontentsl .hongbaobtncont .hongbaobtncontinner .hbyanshiylq[data-v-4f04d936] {
  float:left;
  width:5.46667rem;
  height:2.18667rem;
  background:url(/static/img/ylq.9efab72b.png) no-repeat;
  background-size:100% 100%;
  margin-top:.08rem
}
.index-container .hbpopclass .hbcontentsl .xxbtn[data-v-4f04d936] {
  float:left;
  width:1.28rem;
  height:1.28rem;
  margin-left:4.26667rem
}
.index-container .hbpopclass .dkhbsssss[data-v-4f04d936] {
  width:7.17333rem;
  height:8.45333rem;
  position:relative;
  top:50%;
  margin:0 auto;
  -webkit-transform:translateY(-50%);
  -ms-transform:translateY(-50%);
  transform:translateY(-50%);
  background:url(/static/img/hbimg.a1d1f8b4.png) no-repeat;
  background-size:100% 100%
}
.index-container .hbpopclass .dkhbsssss .icoimg[data-v-4f04d936] {
  float:left;
  width:.85333rem;
  height:.85333rem;
  margin:1.12rem 0 0 5.22667rem
}
.index-container .hbpopclass .dkhbsssss .hbjinecont[data-v-4f04d936] {
  float:left;
  width:100%;
  margin-top:1.17333rem
}
.index-container .hbpopclass .dkhbsssss .hbjinecont .hbtitle[data-v-4f04d936] {
  height:.32rem;
  font-size:.32rem;
  color:#fff
}
.index-container .hbpopclass .dkhbsssss .hbjinecont .hbtitle[data-v-4f04d936],
.index-container .hbpopclass .dkhbsssss .hbjinecont .qbgsss[data-v-4f04d936] {
  float:left;
  width:100%;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.index-container .hbpopclass .dkhbsssss .hbjinecont .qbgsss[data-v-4f04d936] {
  height:.77333rem;
  font-size:1.01333rem;
  font-weight:600;
  color:#ffe9ac;
  margin-top:.24rem;
  margin-bottom:.16rem
}
.index-container .hbpopclass .dkhbsssss .hbjinecont .textcmnetdss[data-v-4f04d936] {
  float:left;
  width:100%;
  font-size:.32rem;
  font-family:PingFang SC;
  font-weight:500;
  color:#fff;
  line-height:.42667rem;
  text-align:center;
  margin-top:.66667rem
}
.index-container .hbpopclass .dkhbsssss .hbbbtn[data-v-4f04d936] {
  float:left;
  position:absolute;
  width:3.33333rem;
  height:1.12rem;
  bottom:1.65333rem;
  left:1.92rem;
  background:url(data:image/png;base64,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) no-repeat;
  background-size:100% 100%
}
.index-container .warpper[data-v-4f04d936] {
  background:#fff
}
.index-container .warpper .bottom-taps[data-v-4f04d936] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  position:fixed;
  height:1.30667rem;
  bottom:0;
  border-top:.02667rem solid #fff;
  box-shadow:0 0 .53333rem 0 rgba(102,118,165,.15);
  width:100%;
  max-width:10rem;
  background:#fff;
  padding-top:.13333rem;
  border-radius:.26667rem .26667rem 0 0
}
.index-container .warpper .bottom-taps .bottom-taps-list[data-v-4f04d936] {
  width:25%;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-orient:vertical;
  -webkit-box-direction:normal;
  -webkit-flex-direction:column;
  -ms-flex-direction:column;
  flex-direction:column;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  color:#6b7db2
}
.index-container .warpper .bottom-taps .bottom-taps-list img[data-v-4f04d936] {
  width:.58667rem
}
.index-container .warpper .bottom-taps .bottom-taps-list p[data-v-4f04d936] {
  line-height:.58667rem;
  height:.58667rem;
  margin:0 0
}
.index-container .warpper .bottom-taps .tapsactive[data-v-4f04d936] {
  color:#2385ff
}
.readnums[data-v-4f04d936] {
  margin-right:.26667rem;
  background:#f81b1b;
  padding:.02667rem .13333rem;
  color:#fff;
  border-radius:.26667rem;
  position:absolute;
  margin-left:.26667rem
}
</style>



// WEBPACK FOOTER //
// src/components/mode/mine.vue